import config from '@/config'

export function loadImage(image: any): Promise<any> {
  return new Promise((resolve, reject) => {
    image.addEventListener('load', () => {
      resolve(image)
    })
    image.addEventListener('error', (error: Error) => {
      reject(error)
    })
  })
}
export async function validateAspectRatio(
  image: { width: number; height: number },
  expectedAspectRatio: string
): Promise<any> {
  return new Promise((resolve, reject) => {
    const width = image.width
    const height = image.height
    const aspectRatio = (width / height).toFixed(2)
    if (aspectRatio != expectedAspectRatio) {
      reject('Invalid Aspect Ratio')
    } else {
      resolve('Valid Aspect Ratio')
    }
  })
}

export const replaceBucketUrlWithCdnUrl = (value: any): any => {
  try {
    if (!value) {
      return value
    }

    let assetUrl
    if (typeof value === 'object') {
      assetUrl = value.backgroundImage
    } else {
      assetUrl = value
    }

    // Check if blob is present in either communities or client portal bucket
    const communitiesBucketIndex = assetUrl.indexOf(
      config.COMMUNITIES_STORAGE_BUCKET
    )

    const clientPortalBucketIndex = assetUrl.indexOf(
      config.CLIENT_PORTAL_STORAGE_BUCKET
    )

    // If value is neither a client-portal nor communities bucket URL, return value itself
    if (communitiesBucketIndex === -1 && clientPortalBucketIndex === -1) {
      return value
    }

    // Check if URL is already a communities or client portal bucket CDN URL
    const communitiesCdnIndex = assetUrl.indexOf(config.COMMUNITIES_CDN_URL)

    const clientPortalCdnIndex = assetUrl.indexOf(config.CLIENT_PORTAL_CDN_URL)

    let newAssetUrl

    // If it's a URL then let's append the CDN URL
    if (communitiesBucketIndex !== -1) {
      newAssetUrl =
        config.COMMUNITIES_CDN_URL +
        assetUrl.substring(
          communitiesBucketIndex + config.COMMUNITIES_STORAGE_BUCKET.length
        )
    } else if (clientPortalBucketIndex !== -1) {
      newAssetUrl =
        config.CLIENT_PORTAL_CDN_URL +
        assetUrl.substring(
          clientPortalBucketIndex + config.CLIENT_PORTAL_STORAGE_BUCKET.length
        )
    }

    if (typeof value === 'object') {
      return communitiesBucketIndex !== -1 || clientPortalBucketIndex !== -1
        ? { backgroundImage: `url(${newAssetUrl}` }
        : value
    }

    return communitiesCdnIndex !== -1 || clientPortalCdnIndex !== -1
      ? value
      : newAssetUrl
  } catch (e) {
    console.error(e)
    return value
  }
}

export const dataUrlToBlob = (dataUrl: string | undefined): Promise<Blob> => {
  if (dataUrl === undefined) return Promise.reject('DataUrl is undefined')
  return new Promise((resolve, reject) => {
    try {
      const arr = dataUrl.split(',')
      // Extract mime time, capture any characters that are between a ":" and a ";"
      const mime = arr[0].match(/:(.*?);/)![1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      resolve(new Blob([u8arr], { type: mime }))
    } catch (error) {
      reject(error)
    }
  })
}
